import React from "react";
import { Field } from "formik";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

const AvailabilityStep = () => {
  const AVAILABILITY_STEP_STRINGS =
    GeneralStrings.ENROLL.FORM_LABELS.AVAILABILITY_STEP;
  return (
    <div className="step">
      <h4
        className="step-header"
        dangerouslySetInnerHTML={{
          __html: AVAILABILITY_STEP_STRINGS.HEADER_HTML,
        }}
      />
      <div className="question-container">
        <FormGroup
          name="weekdayAvailability"
          className="form-group day-container"
        >
          <div>
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailability"
              label="Sunday"
              value="Sunday"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailability"
              label="Monday"
              value="Monday"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailability"
              label="Tuesday"
              value="Tuesday"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailability"
              label="Wednesday"
              value="Wednesday"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailability"
              label="Thursday"
              value="Thursday"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailability"
              label="Friday"
              value="Friday"
            />
            <Field
              type="checkbox"
              as={FormControlLabel}
              control={<Checkbox />}
              name="weekdayAvailability"
              label="Saturday"
              value="Saturday"
            />
          </div>
        </FormGroup>
      </div>
    </div>
  );
};

export default AvailabilityStep;
